import action from './action.json';

export default {
  action,
};
